import React, {Suspense} from "react";
import {Button, Modal} from 'react-bootstrap';
import {AdministrationUtilities} from "../../administration/AdministrationHelper";

export class InfoMenu extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            BodyComponent: null
        };

        this.installationId = AdministrationUtilities.getInstallationId();

        this._open = this._open.bind(this);
        this._close = this._close.bind(this);

        // Cache dei componenti già caricati
        this._cache = {};
    }

    async _open(bodyName, title) {

        // Se già in cache → istantaneo
        if (this._cache[bodyName]) {
            this.setState({
                show: true,
                BodyComponent: this._cache[bodyName],
                title
            });
            return;
        }

        const contentsFolder = this.props.contentsFolder || 'credit_contents';

        try {
            // 1) Provo a caricare il body richiesto
            const module = await import(
                `../../_custom-layout/${this.installationId}/${contentsFolder}/${bodyName}.js`
                );

            this._cache[bodyName] = module.default;

            this.setState({
                show: true,
                BodyComponent: module.default,
                title
            });

        } catch (err) {

            // 2) Provo un fallback custom (opzionale)
            try {
                const fallbackModule = await import(
                    `../../_custom-layout/${this.installationId}/${contentsFolder}/FallbackBody.js`
                    );

                this._cache[bodyName] = fallbackModule.default;

                this.setState({
                    show: true,
                    BodyComponent: fallbackModule.default,
                    title
                });

            } catch (err2) {

                // 3) Fallback generico (sempre presente)
                const { default: GenericFallback } = await import(
                    "./FallbackBody.js"
                    );

                this._cache[bodyName] = GenericFallback;

                this.setState({
                    show: true,
                    BodyComponent: GenericFallback,
                    title
                });
            }
        }
    }

    _close() {
        this.setState({show: false});
    }

    render() {
        const BodyComponent = this.state.BodyComponent;

        return (
            <Modal
                id={`credits-modal-${this.installationId}`}
                show={this.state.show}
                onHide={this._close}>
                <Modal.Header closeButton>
                    <Modal.Title id={`credits-modal-${this.installationId}-title`}>
                        {this.state.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {BodyComponent && <BodyComponent/>}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this._close}>Chiudi</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

